if (
  document.URL.match(/edit_profile/) ||
  document.URL.match(/update_profile/) ||
  document.URL.match(/registrations\/profile/) ||
  document.URL.match(/registrations\/create_profile/)
) {
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".remove_fields").forEach((element) => {
      element.addEventListener("click", (event) => {
        event.preventDefault();

        element.parentElement.parentElement.style.display = "none";
        element.previousElementSibling.value = "1";
      });
    });

    const insertionPoint = document.getElementById("insertionPoint");
    document.querySelectorAll(".add_fields").forEach((element) => {
      element.addEventListener("click", (event) => {
        event.preventDefault();

        let time = new Date().getTime();
        let newFields = element.dataset.fields.replace(
          /__user_resumes_index__/g,
          time
        );

        insertionPoint.insertAdjacentHTML("beforebegin", newFields);
      });
    });
  });
}
